// src/theme.js
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#52057b", // Aapka diya hua color
    },
    secondary: {
      main: "#ffffff",
    },
  },
  typography: {
    fontFamily: "Arial, sans-serif", // Aap logo ke font style ke hisaab se change kar sakte hain
    h4: {
      fontWeight: 700,
    },
  },
});
